module.exports = __webpack_public_path__ + "img/engelstrompete_5.cec1d36d.jpg";